<app-center-view title="Your forum" [isLoading]="isLoading" [error]="error">
  <label class="label-text">Choose your tribe</label>
  <div class="mobile-transparent-theme">
    <app-select
      placeholder="Tribe name"
      [(ngModel)]="selectedTribe"
      (ngModelChange)="onTribeChange()"
    >
      @for (tribe of tribes; track tribe) {
        <app-option [value]="tribe.id" [displayText]="tribe.name"></app-option>
      }
    </app-select>
  </div>

  <label class="label-text">Choose your character</label>
  <div class="mobile-transparent-theme">
    <app-select
      placeholder="Character name"
      [disabled]="!selectedTribe"
      [(ngModel)]="selectedCharacter"
    >
      @for (character of characterList; track character) {
        <app-option [value]="character.id" [displayText]="character.name"> </app-option>
      }
    </app-select>
  </div>

  <label class="label-text">Choose your name</label>
  <input type="text" [disabled]="!selectedTribe" [(ngModel)]="name" />

  <button mat-raised-button appThemedButton [disabled]="isSubmitDisabled" (click)="onSubmit()">
    DONE
  </button>
  <p class="message">If you choose your forum, you can not change it.</p>
</app-center-view>
